export default __webpack_public_path__ + "static/media/covid-19-virus.6e01eac4.webp";